import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ConsultarCinPPTRequest, Types } from './types';

// ACTIONS
import { consultarCinPPTSuccess, consultarCinPPTFailure } from './actions';

function* consultarCinPPTRequest(request: ReducerActionRotaSP) {
	const token: string = yield select(state => state.user.token.data);
	const { payload }: { payload: any } = request;
	const { data }: { data: ConsultarCinPPTRequest } = payload;
	const { usuario, ...params } = data;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'cin',
		params,
		undefined,
		undefined,
		undefined,
		usuario,
		undefined,
	);

	if (response.status === 200) {
		yield put(consultarCinPPTSuccess(response));
	} else {
		yield put(consultarCinPPTFailure(response));
	}
}

export default all([
	takeLatest(Types.CONSULTAR_CIN_PPT_REQUEST, consultarCinPPTRequest),
]);
